import React from 'react';
import './BotManagement.scss';
import { connect } from 'react-redux';
// eslint-disable-next-line max-len
import BotManagementDetailInputs from '../../components/BotManagementDetailInputs/BotManagementDetailInputs';

function BotManagement({ ...props }) {
  return (
    <div >
      <BotManagementDetailInputs isEdit={false} />
    </div>
  );
}
const mapStateToProps = (state) => {
  return {};
};
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(BotManagement);
